var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mx-auto border border-grey-2 rounded-lg my-2 flex"},[_c('div',{staticClass:"flex w-full"},[_c('SideBarAdmin',{attrs:{"menu":_vm.admin}}),_c('div',{staticClass:"flex h-screen w-11/12 -ml-28 my-2 border border-black rounded pl-4 pr-4 col-lg mt-7 mr-7 pt-2 pb-2"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }